import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useUrlSearchParams } from "use-url-search-params";
import { Breadcrumb, Table } from 'antd';

import Pagination from "containers/Pagination";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import { usePairs } from 'modules/aiSearch/hooks';
import FilterList from './components/FilterList';

const AIPairsSearch = () => {
  const { t } = useTranslation();
  const [params, setParams] = useUrlSearchParams();
  const [search, setSearch] = useState(0);

  const defaultParams = {
    search: search,
    page: params.page,  
    name: params.name
  }

  const { pairs, meta, isFetched } = usePairs({
    params: defaultParams
  });

  const columns = [
    {
      title: t('registered_number'),
      dataIndex: 'id',
      width: 60
    },
    {
      title: t('function_name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('organization_name'),
      dataIndex: 'organization',
      key: 'organization',
      width: 300
    }
  ];

  return (
    <Container>
      <Spacer size={35} />

      <Breadcrumb separator=">">
        <Breadcrumb.Item href="/mandatory-requirement/register">{t('home')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('ai-search-by-pairs')}</Breadcrumb.Item>
      </Breadcrumb>

      <Spacer size={32} />

      <Title align="left" text={`${t('ai-search-by-pairs')}`} />
      <Spacer size={32} />

      <FilterList {...{ params, setParams, setSearch }} />

      {
        Object.entries(pairs).map(([_, items], index) => (<>
          <Spacer size={40} />
          <Title align="left" text={`${t('similarity_group')}: ${index + 1}`} />
          <Spacer size={20} />

          <Table
            rowKey="id"
            columns={columns}
            dataSource={items}
            pagination={false}
            loading={!isFetched}
            scroll={{ x: 800 }}
            locale={{
              emptyText: t("functions-not-found")
            }}
          />
        </>))
      }

      <Spacer size={32} />

      <Pagination
        current={meta.page}
        total={Math.ceil(meta.total / meta.perPage)}
        currentItems={Object.values(pairs)
          .reduce((sum, items) => sum + items.length, 0)}
        totalItems={meta.total}
        onChange={page => setParams({ page })}
      />

      <Spacer size={140} />
    </Container>
  );
};

export default AIPairsSearch;
